import React, { useEffect, useState } from "react";
import { obterPortalVagas, enviarPortalVagas } from "../services/api";

// 🔗 A empresa cola o link da página de vagas ou do ATS (17/10/2026). Fica aguardando a equipe do eaiRH ativar;
// ativado, as vagas novas entram sozinhas no portal e as fechadas saem.
const NOMES_ATS = { quickin: "Quickin", gupy: "Gupy", inhire: "InHire", kenoby: "Kenoby", solides: "Sólides", breezy: "Breezy",
  manatal: "Manatal", successfactors: "SAP SuccessFactors", workday: "Workday", greenhouse: "Greenhouse", lever: "Lever" };

export default function LinkVagasEmpresa() {
  const [dados, setDados] = useState(null);
  const [url, setUrl] = useState("");
  const [msg, setMsg] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  // 22/10/2026: o campo começa VAZIO quando a leitura já está ativa (antes mostrava o "a|b" cru do banco)
  useEffect(() => { obterPortalVagas().then((d) => { setDados(d); setUrl(d.sugerido || ""); }).catch(() => setDados({})); }, []);
  if (!dados) return null;
  const enviar = async (e) => {
    e.preventDefault(); setErro(""); setMsg(""); setEnviando(true);
    try {
      const r = await enviarPortalVagas(url.trim());
      if (r.ativado) {
        // o teste leu as vagas na hora: ativado sem esperar a equipe
        const d = await obterPortalVagas().catch(() => null);
        if (d) setDados(d);
        setUrl("");
        setMsg(`Pronto! Conseguimos ler ${r.vagas} vaga${r.vagas === 1 ? "" : "s"} nesse link. A leitura já está ativa: as vagas entram no eaiRH na próxima atualização, e as novas entram sozinhas.`);
      } else if (r.jaAtivo) {
        // link que o espelho já lê (ex.: o de uma vaga só): não precisa de aprovação nem de link por vaga
        setUrl("");
        setMsg("Esse link já está coberto: as vagas dessa página entram no eaiRH sozinhas, inclusive as novas. Não precisa enviar o link de cada vaga.");
      } else {
        setDados({ ...dados, sugerido: r.sugerido, sugeridoEm: new Date().toISOString(), ats: r.ats });
        setMsg("Recebemos o link! Nossa equipe confere e ativa a leitura das vagas; você recebe o aviso quando estiver no ar.");
      }
    } catch (er) { setErro(er.message); }
    setEnviando(false);
  };
  const ativo = dados.ativo && !dados.sugerido;
  const ativos = dados.ativos && dados.ativos.length ? dados.ativos : (dados.ativo ? [dados.ativo] : []);
  const nomeAts = dados.ats ? (NOMES_ATS[dados.ats] || dados.ats) : null;
  return (
    <div className="bg-white rounded-2xl shadow-sm p-5">
      <h2 className="font-bold text-text text-lg">Vagas automáticas</h2>
      <p className="text-sm text-gray-600 mt-1">Cole o link da página de vagas da empresa ou do seu ATS (Quickin, Gupy, InHire, Kenoby e outros).
        Depois de ativado, as vagas novas entram no eaiRH sozinhas e as fechadas saem, sem cadastrar uma por uma.</p>
      {ativo
        ? <div className="mt-3 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">
            ✅ Leitura ativa{nomeAts ? ` (${nomeAts})` : ""}. As vagas novas entram sozinhas; não precisa enviar o link de cada vaga.
            {ativos.map((a) => <div key={a} className="break-all text-xs mt-1">{a}</div>)}</div>
        : dados.sugerido
          ? <p className="mt-3 rounded-xl bg-amber-50 border border-amber-200 text-amber-800 text-sm px-3 py-2">⏳ Link enviado{nomeAts ? ` (${nomeAts})` : ""}, aguardando ativação pela equipe do eaiRH.</p>
          : null}
      <form onSubmit={enviar} className="flex flex-wrap gap-2 mt-3">
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://jobs.quickin.io/suaempresa/jobs"
          className="flex-1 min-w-[16rem] border border-gray-300 rounded-lg px-3 py-2 text-sm" maxLength={500} />
        <button disabled={enviando || !url.trim()} className="bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm disabled:opacity-50">
          {enviando ? "Enviando…" : "Enviar link"}</button>
      </form>
      {msg && <p className="text-sm text-green-700 mt-2">{msg}</p>}
      {erro && <p className="text-sm text-red-600 mt-2">{erro}</p>}
    </div>
  );
}
